import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import {
    CreateNotificationTypeRequest,
    NotificationType
} from '@/modules/configurationModule/detail/notifications/models/notification-types'
import { CommonPaginatorResourceService } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { CommonLaboratoryResponse, TranslationResponse } from '@/api/services/common.dto'
import { notificationTypesGridColumnDefs } from '@/modules/configurationModule/detail/notifications/components/notification-types-grid/notification-types-grid.column-defs'

export interface ContentNotificationTypesGrid {
    id?: number
    emailChannelActive?: boolean
    inboxChannelActive?: boolean
    smsChannelActive?: boolean
    laboratory?: Nullable<CommonLaboratoryResponse>
    notificationType?: Nullable<NotificationType>
    plainBodyTranslations: TranslationResponse[]
    subjectTranslations: TranslationResponse[]
    htmlBodyTranslations: TranslationResponse[]
}

export interface NotificationTypesGridService extends CommonPaginatorResourceService<any> {
    createGlobalNotification(request: CreateNotificationTypeRequest, laboratoryId: number): Promise<ContentNotificationTypesGrid>
    deleteGlobalNotificationBatch(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]>
}
export interface NotificationTypesGridState extends CrudModelPaginatorLaboratory<ContentNotificationTypesGrid> {
    service: StrictNullable<NotificationTypesGridService>
}
export const initialNotificationTypesGridCrudModelBase =
    (): NotificationTypesGridState => ({
        ...initialCrudModelBaseState(),
        columnsDef: notificationTypesGridColumnDefs([]),
        service: null
    })
